import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagAnalystProps {}

const ColorTagAnalyst: React.FC<ColorTagAnalystProps> = props => {
  return <ColorTag className="ColorTagAnalyst" color="navy" appearance="translucent">Analyst</ColorTag>
}

export default ColorTagAnalyst;